import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { quizAPI, challengeAPI, progressAPI } from "../services/api";
import useApi from "../hooks/useApi";
import { getCurrentUser } from "../utils/auth";
import { motion } from "framer-motion";

const Dashboard = () => {
  const user = getCurrentUser();
  const { data: quizzes, loading: quizzesLoading } = useApi(quizAPI.getQuizzes);
  const { data: challenges, loading: challengesLoading } = useApi(
    challengeAPI.getChallenges
  );
  const { data: progress, loading: progressLoading } = useApi(
    progressAPI.getProgress
  );

  const loading = quizzesLoading || challengesLoading || progressLoading;

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        {/* Icône animée */}
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
          className="w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full mb-6"
        ></motion.div>

        {/* Texte animé */}
        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.5,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          className="text-lg font-semibold text-gray-700"
        >
          Chargement en cours...
        </motion.h2>

        {/* Barre de progression animée */}
        <motion.div className="w-48 h-2 bg-gray-200 rounded-full mt-4 overflow-hidden">
          <motion.div
            className="h-full bg-orange-500"
            initial={{ x: "-100%" }}
            animate={{ x: "100%" }}
            transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <h1>Welcome, {user?.firstName}!</h1>

      {/* Progress Overview */}
      <div className="row mt-4">
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Quiz Progress</h5>
              <p className="card-text">
                Completed: {progress?.quizProgress?.completed || 0} /{" "}
                {progress?.quizProgress?.total || 0}
              </p>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${
                      (progress?.quizProgress?.completed /
                        progress?.quizProgress?.total) *
                        100 || 0
                    }%`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Challenge Progress</h5>
              <p className="card-text">
                Completed: {progress?.challengeProgress?.completed || 0} /{" "}
                {progress?.challengeProgress?.total || 0}
              </p>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${
                      (progress?.challengeProgress?.completed /
                        progress?.challengeProgress?.total) *
                        100 || 0
                    }%`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Overall Score</h5>
              <p className="card-text">Score: {progress?.overallScore || 0}%</p>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${progress?.overallScore || 0}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Quizzes */}
      <div className="row mt-4">
        <div className="col-12">
          <h3>Recent Quizzes</h3>
          <div className="row">
            {quizzes?.slice(0, 3).map((quiz) => (
              <div key={quiz.id} className="col-md-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">{quiz.title}</h5>
                    <p className="card-text">{quiz.description}</p>
                    <Link to={`/quiz/${quiz.id}`} className="btn btn-primary">
                      Continue Quiz
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Recent Challenges */}
      <div className="row mt-4">
        <div className="col-12">
          <h3>Recent Challenges</h3>
          <div className="row">
            {challenges?.slice(0, 3).map((challenge) => (
              <div key={challenge.id} className="col-md-4">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">{challenge.title}</h5>
                    <p className="card-text">{challenge.description}</p>
                    <Link
                      to={`/challenge/${challenge.id}`}
                      className="btn btn-primary"
                    >
                      Continue Challenge
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
